import React from 'react'
import bannerImg from "../../../../assets/images/vedioTutorialBanner.png";


function HeaderSection() {
  return (
    <div>

<section id="hero-2" className="hero-2 d-flex align-items-center">
          <div className="container-fluid">
            <div className="hero-border">
              
                <div className="hero-background">
                  <img src={bannerImg} alt="" className="img-fluid banner-img" style={{borderRadius:"5px"}} />
                  </div>
                
            </div>
          </div>
        </section>
      </div>
  )
}

export default HeaderSection